import React from "react";
import {
  ControlTower,
  ControlTowerContext,
  WORKFLOW_TAB_KEYS,
} from "@jsq/control-tower-components";
import { Flex } from "@jsq/ds/core";
import { TabSection } from "../TabSection";
import { getControlTowerTabs } from "../TabSection/tabConfig";
import * as styles from "./styles_vanilla.css";

type WorkflowViewProps = {
  showManagerTabs?: boolean;
  hasWorkflowAccess?: boolean;
};

export const WorkflowView: React.FC<WorkflowViewProps> = ({
  showManagerTabs = false,
  hasWorkflowAccess = false,
}) => {
  const tabs = getControlTowerTabs(showManagerTabs, hasWorkflowAccess);

  return (
    <Flex flexDirection="column" className={styles.container} data-testid="workflow-view">
      <TabSection tabs={tabs} showManagerTabs={showManagerTabs} />
      <div className={styles.contentContainer}>
        <ControlTower
          context={ControlTowerContext.CANOPY}
          defaultWorkflowTab={showManagerTabs ? WORKFLOW_TAB_KEYS.ALL_WORKFLOWS : undefined}
        />
      </div>
    </Flex>
  );
};
